import React, { Component } from "react";
import { Form, Input, Button, notification } from "antd";
import styled from "styled-components";
import createCategory from "../../graphql/mutates/createCategory";
import { apolloClient } from "../../apollo-client";
import updateCategory from "../../graphql/mutates/updateCategory";

const Container = styled.div`
  .btn {
    margin-right: 5px;
  }
`;
class CategoryForm extends Component {
  formRef = React.createRef();
  onFinish = (values) => {
    const id = this.props.showDrawer?.id;
    if (!id) {
      apolloClient
        .mutate({
          mutation: createCategory,
          variables: {
            input: values,
          },
        })
        .then(() => {
          notification.success({ message: "Add category success!" });
          this.formRef.current.resetFields();
          this.props.refetch();
          this.props.onClose();
        });
    } else {
      apolloClient
        .mutate({
          mutation: updateCategory,
          variables: {
            id: id,
            input: values,
          },
        })
        .then(() => {
          notification.success({ message: "Edit category success!" });
          this.formRef.current.resetFields();
          this.props.refetch();
          this.props.onClose();
        });
    }
  };
  render() {
    const layout = {
      labelCol: {
        span: 24,
      },
      wrapperCol: {
        span: 24,
      },
    };
    const { showDrawer, onClose } = this.props;
    return (
      <Container>
        <Form ref={this.formRef} {...layout} onFinish={this.onFinish}>
          <Form.Item
            label="Name"
            name="title"
            rules={[{ required: true, message: "Please input name!" }]}
            initialValue={showDrawer ? showDrawer.title : ""}
          >
            <Input placeholder="Name" />
          </Form.Item>
          <Form.Item
            label="Description"
            name="description"
            initialValue={showDrawer.description}
          >
            <Input.TextArea placeholder="Description" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="btn">
              {showDrawer.id ? "Save change" : "Save"}
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </Form.Item>
        </Form>
      </Container>
    );
  }
}

export default CategoryForm;
